import React, { Component } from 'react';


class Goodbye extends Component {

  render() {
    const { translation } = this.props;
    return (
        <main className="page__container label-page">
            <img className="label-page__image label-page__image--list" src="/images/list.png" alt="List" />
            <h1 className="label-page__heading">{this.props.survey.final_message}</h1>
            {/* <p>
              <span className="label-page__dimmed-text">¡{translation('YOU_HAVE_RECEIVED')} </span>
              <b>{this.props.rewards} pts!</b>
            </p> */}
            <label className="label-page__main-button main-button main-button--colored" onClick={  ()=>   window.open('gbrappi://com.grability.rappi?goto=home', '_self')  }>
                {translation('GO_BACK_RAPPI')}
            </label>
        </main>

    );
  }

}

export default Goodbye;
